import Layout from 'components/layout/Layout';
import SuperAdminLayout from 'components/layout/SuperAdminLayout';
import {
  Login,
  Otp,
  Dashboard,
  BookingDetails,
  OnBoardingForm,
  Company,
  Employee,
  NewEmployee,
  Reservation,
  NewReservation,
  SubVendors,
  Drivers,
  Reports,
  Billing,
  Dispatch,
  Allot,
  AllRides,
  Vehicle,
  VehicleDetails,
  SubVendorDetails,
  CompanyProfile,
  Vendor,
  VendorDetails,
  ViewDriverVendor,
  VechileSubVendorView,
  Payment,
  NewPayment,
  Setting,
  AuditTrail,
  Notification,
  BookingReport,
  CorporateCustomer,
  BillingPerformaInvoice,
  BillingDutySlip,
  PaymentDetails,
  BillingConsolidateInvoice,
  ComplianceTable,
  ComplianceDocument,
  MisReport,
  AssignDriverView,
  AssignVehicleView,
  RegionalManagerView,
  BillingIndividualInvoice,
  AddComplianceView,
  SubVendorB2B,
  AddCabView,
  AddFeedbackView,
  FAQ,
  FAQView,
  DriverDetails,
  PublicFAQ,
  // CustomerPolicy,
  // CancellationPolicy,
  // CustomerTAC,
  // CustomerAboutUs,
  // Help,
  // TripDetails,
  BillingDutySlipPDF,
  BillingPerfomaInvoicePDF,
  MapTest,
  TollCharge,
  ManageInvoice,
  ManageInvoiceBookingDetails,
  TaxConfiguration,
  QrPaymentReport,
  SealSign,
} from './components';
import RateCardNew from 'pages/company/rateCardNew/rateCardNew';
import TenantConsole from 'pages/tenantManagement/TenantConsole';
import SelectTenant from 'pages/tenantManagement/SelectTenant';
import SuperAdminProfile from 'pages/tenantManagement/SuperAdminProfile';
import GeneratedReports from 'pages/reports/generatedReports/GeneratedReports';
import CustomerComplaintsTable from 'pages/customerComplaints/CustomerComplaintsTable';
import CustomerComplaintView from 'pages/customerComplaints/CustomerComplaintView';
import LiveCabsMap from 'pages/liveTracking/LiveCabsMap';
import PromotionalTab from 'pages/promotional/PromotionalTab';
import CouponDetails from 'pages/promotional/coupon/CouponDetails';
import RolesAndPermissions from 'pages/rolesAndPermissions/RolesAndPermissions';
import SubRoleDetail from 'pages/rolesAndPermissions/SubRoleDetail';
import SubRolesPage from 'pages/rolesAndPermissions/SubRolesPage';

export const routeConfigAuth = [
  { path: '/', component: Login, layout: null, isAuth: false },
  { path: '/login', component: Login, layout: null, isAuth: false },
  { path: '/otp', component: Otp, layout: null, isAuth: false },
  {
    path: '/download-dutyslip/',
    component: BillingDutySlipPDF,
    layout: null,
    isAuth: false,
  },
  {
    path: '/download-invoice/',
    component: BillingPerfomaInvoicePDF,
    layout: null,
    isAuth: false,
  },
  {
    path: '/download-consolidatedinvoice/',
    component: BillingConsolidateInvoice,
    layout: null,
    isAuth: false,
  },
  {
    path: '/download-individualinvoice/',
    component: BillingIndividualInvoice,
    layout: null,
    isAuth: false,
  },
  { path: '/faq/', component: PublicFAQ, layout: null, isAuth: false },
  { path: '/maps', component: MapTest, layout: null, isAuth: false },
];

//Dynamic routing configuration
export const routeConfigDynamic = [
  { path: '/', component: Login, layout: null, isAuth: false },
  { path: '/login', component: Login, layout: null, isAuth: false },
  { path: '/otp', component: Otp, layout: null, isAuth: false },
  {
    path: '/dashboard',
    component: Dashboard,
    layout: Layout,
    isAuth: true,
    moduleKey: 'dashboard',
  },
  {
    path: '/sub-vendor',
    component: SubVendors,
    layout: Layout,
    isAuth: true,
    moduleKey: 'subvendor',
  },
  {
    path: '/sub-vendor/details',
    component: SubVendorDetails,
    layout: Layout,
    isAuth: true,
    moduleKey: 'subvendor',
  },
  {
    path: '/sub-vendor/driver/details',
    component: ViewDriverVendor,
    layout: Layout,
    isAuth: true,
    moduleKey: 'subvendor',
  },
  {
    path: '/sub-vendor/driver/details',
    component: ViewDriverVendor,
    layout: Layout,
    isAuth: true,
    moduleKey: 'citymanager',
  },
  {
    path: '/sub-vendor/vehicle/details',
    component: VehicleDetails,
    layout: Layout,
    isAuth: true,
    moduleKey: 'subvendor',
  },
  {
    path: '/sub-vendor/vehicle/details',
    component: VehicleDetails,
    layout: Layout,
    isAuth: true,
    moduleKey: 'citymanager',
  },
  {
    path: '/driver',
    component: Drivers,
    layout: Layout,
    isAuth: true,
    moduleKey: 'drivers',
  },
  {
    path: '/driver/details',
    component: ViewDriverVendor,
    layout: Layout,
    isAuth: true,
    moduleKey: 'drivers',
  },
  {
    path: '/vehicle',
    component: Vehicle,
    layout: Layout,
    isAuth: true,
    moduleKey: 'vehicle',
  },
  {
    path: '/vehicle/details',
    component: VehicleDetails,
    layout: Layout,
    isAuth: true,
    moduleKey: 'vehicle',
  },
  {
    path: '/companies',
    component: Company,
    layout: Layout,
    isAuth: true,
    moduleKey: 'company',
  },
  {
    path: '/companies/new-booking',
    component: OnBoardingForm,
    layout: Layout,
    moduleKey: 'company',
  },
  {
    path: '/companies/companyprofile/:id',
    component: CompanyProfile,
    layout: Layout,
    isAuth: true,
    moduleKey: 'company',
  },

  {
    path: '/employees',
    component: Employee,
    layout: Layout,
    isAuth: true,
    moduleKey: 'employee',
  },
  {
    path: '/employees/new-employee',
    component: NewEmployee,
    layout: Layout,
    isAuth: true,
    moduleKey: 'employee',
  },
  {
    path: '/employees/employee-profile/:id',
    component: NewEmployee,
    layout: Layout,
    isAuth: true,
    moduleKey: 'employee',
  },
  {
    path: '/reservation',
    component: Reservation,
    layout: Layout,
    isAuth: true,
    moduleKey: 'reservation',
  },
  {
    path: '/reservation/new-reservation',
    component: NewReservation,
    layout: Layout,
    isAuth: true,
    moduleKey: 'reservation',
  },
  {
    path: '/reservation/bookingdetails',
    component: BookingDetails,
    layout: Layout,
    isAuth: true,
    moduleKey: 'reservation',
  },
  {
    path: '/manage-invoice',
    component: ManageInvoice,
    layout: Layout,
    isAuth: true,
    moduleKey: 'manageInvoice',
  },
  {
    path: '/manage-invoice/bookingdetails',
    component: ManageInvoiceBookingDetails,
    layout: Layout,
    isAuth: true,
    moduleKey: 'manageInvoice',
  },
  // QA (invoice "404 Page not found"): the invoice-generation flow is reached
  // from Manage Invoice (module 'manageInvoice'), but its pages live under
  // /operation/billing/* scoped to module 'operation'. The tenant Admin role has
  // manageInvoice but NOT operation, so "Generate Invoice" navigated to a route
  // filtered out of its menu -> 404. Expose the flow under manageInvoice too; the
  // operation-scoped copies below remain for operation roles.
  {
    path: '/operation/billing/duty-slip',
    component: BillingDutySlip,
    layout: Layout,
    isAuth: true,
    moduleKey: 'manageInvoice',
  },
  {
    path: '/operation/billing/performa-invoice',
    component: BillingPerformaInvoice,
    layout: Layout,
    isAuth: true,
    moduleKey: 'manageInvoice',
  },
  {
    path: '/operation/billing/consolidate-invoice',
    component: BillingConsolidateInvoice,
    layout: Layout,
    isAuth: true,
    moduleKey: 'manageInvoice',
  },
  {
    path: '/operation/billing/individual-invoice',
    component: BillingIndividualInvoice,
    layout: Layout,
    isAuth: true,
    moduleKey: 'manageInvoice',
  },
  {
    path: '/payment',
    component: Payment,
    layout: Layout,
    isAuth: true,
    moduleKey: 'settlement',
  },
  {
    path: '/payment/newpayment',
    component: NewPayment,
    layout: Layout,
    isAuth: true,
    moduleKey: 'settlement',
  },
  {
    path: '/operation/allrides/:tabs',
    component: AllRides,
    layout: Layout,
    isAuth: true,
    moduleKey: 'operation',
  },
  {
    path: '/operation/allrides/bookingdetails',
    component: BookingDetails,
    layout: Layout,
    isAuth: true,
    moduleKey: 'operation',
  },
  {
    path: '/operation/allot',
    component: Allot,
    layout: Layout,
    isAuth: true,
    moduleKey: 'operation',
  },
  {
    path: '/operation/allot/bookingdetails',
    component: BookingDetails,
    layout: Layout,
    isAuth: true,
    moduleKey: 'operation',
  },
  {
    path: '/operation/dispatch',
    component: Dispatch,
    layout: Layout,
    isAuth: true,
    moduleKey: 'operation',
  },
  {
    path: '/operation/dispatch/bookingdetails',
    component: BookingDetails,
    layout: Layout,
    isAuth: true,
    moduleKey: 'operation',
  },
  {
    path: '/operation/billing/:tabs',
    component: Billing,
    layout: Layout,
    isAuth: true,
    moduleKey: 'operation',
  },
  {
    path: '/operation/billing/bookingdetails',
    component: BookingDetails,
    layout: Layout,
    isAuth: true,
    moduleKey: 'operation',
  },
  {
    path: '/operation/billing/duty-slip',
    component: BillingDutySlip,
    layout: Layout,
    isAuth: true,
    moduleKey: 'operation',
  },
  {
    path: '/operation/billing/performa-invoice',
    component: BillingPerformaInvoice,
    layout: Layout,
    isAuth: true,
    moduleKey: 'operation',
  },
  {
    path: '/operation/billing/consolidate-invoice',
    component: BillingConsolidateInvoice,
    layout: Layout,
    isAuth: true,
    moduleKey: 'operation',
  },
  {
    path: '/operation/allotvehicle',
    component: AssignVehicleView,
    layout: Layout,
    isAuth: true,
    moduleKey: 'operation',
  },
  {
    path: '/operation/allotdriver',
    component: AssignDriverView,
    layout: Layout,
    isAuth: true,
    moduleKey: 'operation',
  },
  {
    path: '/report/revenue',
    component: Reports,
    layout: Layout,
    isAuth: true,
    moduleKey: 'revenue',
  },
  {
    path: '/report/mis',
    component: MisReport,
    layout: Layout,
    isAuth: true,
    moduleKey: 'reports',
  },
  {
    path: '/report/qr-payment',
    component: QrPaymentReport,
    layout: Layout,
    isAuth: true,
    moduleKey: 'reports',
  },
  {
    path: '/citymanager',
    component: Vendor,
    layout: Layout,
    isAuth: true,
    moduleKey: 'citymanager',
  },
  {
    path: '/citymanager/details',
    component: VendorDetails,
    layout: Layout,
    isAuth: true,
    moduleKey: 'citymanager',
  },
  {
    path: '/citymanager/driver',
    component: ViewDriverVendor,
    layout: Layout,
    isAuth: true,
    moduleKey: 'citymanager',
  },
  {
    path: '/citymanager/driver/vehicle',
    component: VechileSubVendorView,
    layout: Layout,
    isAuth: true,
    moduleKey: 'citymanager',
  },
  {
    path: '/citymanager/vehicle',
    component: VechileSubVendorView,
    layout: Layout,
    isAuth: true,
    moduleKey: 'citymanager',
  },
  {
    path: '/citymanager/subvendor',
    component: SubVendorDetails,
    layout: Layout,
    isAuth: true,
    moduleKey: 'citymanager',
  },
  {
    path: '/citymanager/subvendor/driver',
    component: ViewDriverVendor,
    layout: Layout,
    isAuth: true,
    moduleKey: 'citymanager',
  },
  {
    path: '/settings',
    component: Setting,
    layout: Layout,
    isAuth: true,
    moduleKey: 'settings',
  },
  {
    path: '/notification',
    component: Notification,
    layout: Layout,
    isAuth: true,
    moduleKey: 'notification',
  },
  {
    path: '/report/booking',
    component: BookingReport,
    layout: Layout,
    isAuth: true,
    moduleKey: 'booking',
  },
  {
    path: '/report-generate',
    component: GeneratedReports,
    layout: Layout,
    isAuth: true,
    moduleKey: 'booking',
  },
  {
    path: '/report/corporatecustomer',
    component: CorporateCustomer,
    layout: Layout,
    isAuth: true,
    moduleKey: 'report',
  },
  {
    path: '/payment/paymentdetails',
    component: PaymentDetails,
    layout: Layout,
    isAuth: true,
    moduleKey: 'settlement',
  },
  {
    path: '/regionaluser',
    component: RegionalManagerView,
    layout: Layout,
    isAuth: true,
    moduleKey: 'regionalmanager',
  },
  {
    path: '/compliance/:tabs',
    component: ComplianceTable,
    layout: Layout,
    isAuth: true,
    moduleKey: 'compliance',
  },
  {
    path: '/compliance/documents',
    component: ComplianceDocument,
    layout: Layout,
    isAuth: true,
    moduleKey: 'compliance',
  },
  {
    path: 'configuration/addcomplaince',
    component: AddComplianceView,
    layout: Layout,
    isAuth: true,
    moduleKey: 'configuration',
  },
  {
    path: '/operation/billing/individual-invoice',
    component: BillingIndividualInvoice,
    layout: Layout,
    isAuth: true,
    moduleKey: 'operation',
  },
  {
    path: 'configuration/addcab',
    component: AddCabView,
    layout: Layout,
    isAuth: true,
    moduleKey: 'configuration',
  },
  {
    path: 'configuration/addfeedback',
    component: AddFeedbackView,
    layout: Layout,
    isAuth: true,
    moduleKey: 'configuration',
  },
  {
    path: 'configuration/faq/:tabs',
    component: FAQ,
    layout: Layout,
    isAuth: true,
    moduleKey: 'configuration',
  },
  {
    path: 'configuration/faq/details/:tabs',
    component: FAQView,
    layout: Layout,
    isAuth: true,
    moduleKey: 'configuration',
  },
  {
    path: 'seal-sign',
    component: SealSign,
    layout: Layout,
    isAuth: true,
    moduleKey: 'seal-sign',
  },
  {
    path: '/ratecard-new',
    component: RateCardNew,
    layout: Layout,
    isAuth: true,
    moduleKey: 'configuration',
  },
  {
    path: 'configuration/tollCharges',
    component: TollCharge,
    layout: Layout,
    isAuth: true,
    moduleKey: 'tollCharges',
  },
  {
    path: 'configuration/taxConfiguration',
    component: TaxConfiguration,
    layout: Layout,
    isAuth: true,
    moduleKey: 'tollCharges',
  },
  {
    path: '/complaints',
    component: CustomerComplaintsTable,
    layout: Layout,
    isAuth: true,
    moduleKey: 'complaints',
  },
  {
    path: '/complaints/detail',
    component: CustomerComplaintView,
    layout: Layout,
    isAuth: true,
    moduleKey: 'complaints',
  },
  {
    path: '/liveTracking',
    component: LiveCabsMap,
    layout: Layout,
    isAuth: true,
    moduleKey: 'liveTracking',
  },
  {
    path: '/promotions',
    component: PromotionalTab,
    layout: Layout,
    isAuth: true,
    moduleKey: 'citymanager',
  },
  {
    path: '/coupon/details',
    component: CouponDetails,
    layout: Layout,
    isAuth: true,
    moduleKey: 'citymanager',
  },
  {
    path: '/promotions',
    component: PromotionalTab,
    layout: Layout,
    isAuth: true,
    moduleKey: 'configuration',
  },
  {
    path: '/coupon/details',
    component: CouponDetails,
    layout: Layout,
    isAuth: true,
    moduleKey: 'configuration',
  },
  {
    path: '/audit-trails',
    component: AuditTrail,
    layout: Layout,
    isAuth: true,
    moduleKey: 'audit-trails',
  },
  {
    path: '/roles-permissions',
    component: RolesAndPermissions,
    layout: Layout,
    isAuth: true,
    moduleKey: 'roles-permissions',
  },
  {
    path: '/roles-permissions/sub-role-detail',
    component: SubRoleDetail,
    layout: Layout,
    isAuth: true,
    moduleKey: 'roles-permissions',
  },
  {
    path: '/roles-permissions/sub-roles',
    component: SubRolesPage,
    layout: Layout,
    isAuth: true,
    moduleKey: 'roles-permissions',
  },
  // Multi-tenancy platform console: no moduleKey on purpose — rolesPermissions
  // never contains a tenant module, so dynamicRoutingByModule drops these;
  // AppRoutes re-adds superAdminOnly routes when the JWT role claim is 99 (UI
  // gate only; the provision/assume APIs enforce the real role-99 check).
  //
  // SuperAdminLayout (NOT the tenant Layout, and NOT layout: null): it renders
  // the platform-console side-nav — giving the super admin Logout + navigation
  // + a Profile page — WITHOUT the tenant Header/module APIs that 403 a role-99
  // session (the original reason these were chromeless layout: null screens).
  //
  // /tenants is the console (Create Tenant + Switch Tenant tabs). The legacy
  // /create-tenant and /select-tenant paths are kept as entry points into the
  // same console (post-login still redirects super admins to /select-tenant).
  {
    path: '/tenants',
    component: TenantConsole,
    layout: SuperAdminLayout,
    isAuth: true,
    superAdminOnly: true,
  },
  {
    path: '/switch-tenant',
    component: SelectTenant,
    layout: SuperAdminLayout,
    isAuth: true,
    superAdminOnly: true,
  },
  {
    path: '/sa-profile',
    component: SuperAdminProfile,
    layout: SuperAdminLayout,
    isAuth: true,
    superAdminOnly: true,
  },
  {
    path: '/create-tenant',
    component: TenantConsole,
    layout: SuperAdminLayout,
    isAuth: true,
    superAdminOnly: true,
  },
  {
    path: '/select-tenant',
    component: SelectTenant,
    layout: SuperAdminLayout,
    isAuth: true,
    superAdminOnly: true,
  },
];

// Company Route config
export const routeConfigCompany = [
  { path: '/companies', component: Company, layout: Layout, isAuth: true },
  {
    path: '/companies/new-booking',
    component: OnBoardingForm,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/companies/companyprofile',
    component: CompanyProfile,
    layout: Layout,
    isAuth: true,
  },
];

// Employee Route config
export const routeConfigEmployee = [
  { path: '/employees', component: Employee, layout: Layout, isAuth: true },

  {
    path: '/employees/new-employee',
    component: NewEmployee,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/employees/employee-profile/:id',
    component: NewEmployee,
    layout: Layout,
    isAuth: true,
  },
];

//Reservation Route config
export const routeConfigReservation = [
  {
    path: '/reservation',
    component: Reservation,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/reservation/new-reservation',
    component: NewReservation,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/reservation/bookingdetails',
    component: BookingDetails,
    layout: Layout,
    isAuth: true,
  },
];

//FrontDesk Route Config
export const routeConfigFleet = [
  { path: '/sub-vendor', component: SubVendors, layout: Layout, isAuth: true },
  {
    path: '/sub-vendor/details',
    component: SubVendorDetails,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/sub-vendor/driver/details',
    component: DriverDetails,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/sub-vendor/vehicle/details',
    component: VehicleDetails,
    layout: Layout,
    isAuth: true,
  },
  { path: '/driver', component: Drivers, layout: Layout, isAuth: true },
  {
    path: '/driver/details',
    component: DriverDetails,
    layout: Layout,
    isAuth: true,
  },
  { path: '/vehicle', component: Vehicle, layout: Layout, isAuth: true },
  {
    path: '/vehicle/details',
    component: VehicleDetails,
    layout: Layout,
    isAuth: true,
  },
];

//Operation Route Config
export const routeConfigOperation = [
  {
    path: '/operation/allrides',
    component: AllRides,
    layout: Layout,
    isAuth: true,
  },
  { path: '/operation/allot', component: Allot, layout: Layout, isAuth: true },
  {
    path: '/operation/dispatch',
    component: Dispatch,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/operation/billing',
    component: Billing,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/operation/allrides/bookingdetails',
    component: BookingDetails,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/operation/allot/bookingdetails',
    component: BookingDetails,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/operation/dispatch/bookingdetails',
    component: BookingDetails,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/operation/billing/bookingdetails',
    component: BookingDetails,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/operation/billing/duty-slip',
    component: BillingDutySlip,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/operation/billing/download-invoice',
    component: BillingPerformaInvoice,
    layout: Layout,
    isAuth: true,
  },
];

//Admin Route config
export const routeConfigAdmin = [
  { path: '/', component: Login, layout: null, isAuth: false },
  { path: '/login', component: Login, layout: null, isAuth: false },
  { path: '/otp', component: Otp, layout: null, isAuth: false },
  { path: '/dashboard', component: Dashboard, layout: Layout, isAuth: true },
  { path: '/sub-vendor', component: SubVendors, layout: Layout, isAuth: true },
  {
    path: '/sub-vendor/details',
    component: SubVendorDetails,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/sub-vendor/driver/details',
    component: ViewDriverVendor,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/sub-vendor/vehicle/details',
    component: VehicleDetails,
    layout: Layout,
    isAuth: true,
  },
  { path: '/driver', component: Drivers, layout: Layout, isAuth: true },
  {
    path: '/driver/details',
    component: ViewDriverVendor,
    layout: Layout,
    isAuth: true,
  },
  { path: '/vehicle', component: Vehicle, layout: Layout, isAuth: true },
  {
    path: '/vehicle/details',
    component: VehicleDetails,
    layout: Layout,
    isAuth: true,
  },
  { path: '/companies', component: Company, layout: Layout, isAuth: true },
  {
    path: '/companies/new-booking',
    component: OnBoardingForm,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/companies/companyprofile/:id',
    component: CompanyProfile,
    layout: Layout,
    isAuth: true,
  },
  { path: '/employees', component: Employee, layout: Layout, isAuth: true },
  {
    path: '/employees/new-employee',
    component: NewEmployee,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/employees/employee-profile/:id',
    component: NewEmployee,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/reservation',
    component: Reservation,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/reservation/new-reservation',
    component: NewReservation,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/reservation/bookingdetails',
    component: BookingDetails,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/operation/allrides/:tabs',
    component: AllRides,
    layout: Layout,
    isAuth: true,
  },
  { path: '/operation/allot', component: Allot, layout: Layout, isAuth: true },
  {
    path: '/operation/dispatch',
    component: Dispatch,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/operation/billing/:tabs',
    component: Billing,
    layout: Layout,
    isAuth: true,
  },
  { path: '/payment', component: Payment, layout: Layout, isAuth: true },
  {
    path: '/payment/newpayment',
    component: NewPayment,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/operation/billing/duty-slip',
    component: BillingDutySlip,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/operation/billing/performa-invoice',
    component: BillingPerformaInvoice,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/operation/billing/consolidate-invoice',
    component: BillingConsolidateInvoice,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/operation/billing/individual-invoice',
    component: BillingIndividualInvoice,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/operation/allrides/bookingdetails',
    component: BookingDetails,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/operation/allot/bookingdetails',
    component: BookingDetails,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/operation/dispatch/bookingdetails',
    component: BookingDetails,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/operation/billing/bookingdetails',
    component: BookingDetails,
    layout: Layout,
    isAuth: true,
  },
  { path: '/report/revenue', component: Reports, layout: Layout, isAuth: true },
  { path: '/report/mis', component: MisReport, layout: Layout, isAuth: true },
  { path: '/citymanager', component: Vendor, layout: Layout, isAuth: true },
  {
    path: '/citymanager/details',
    component: VendorDetails,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/citymanager/driver',
    component: ViewDriverVendor,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/citymanager/driver/vehicle',
    component: VechileSubVendorView,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/citymanager/vehicle',
    component: VechileSubVendorView,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/citymanager/subvendor',
    component: SubVendorDetails,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/citymanager/subvendor/driver',
    component: ViewDriverVendor,
    layout: Layout,
    isAuth: true,
  },
  { path: '/settings', component: Setting, layout: Layout, isAuth: true },
  {
    path: '/notification',
    component: Notification,
    layout: Layout,
    isAuth: true,
  },
  {
    path: 'report/booking',
    component: BookingReport,
    layout: Layout,
    isAuth: true,
  },
  {
    path: 'report/corporatecustomer',
    component: CorporateCustomer,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/payment/paymentdetails',
    component: PaymentDetails,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/compliance/:tabs',
    component: ComplianceTable,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/compliance/documents',
    component: ComplianceDocument,
    layout: Layout,
    isAuth: true,
  },
  {
    path: 'configuration/addcomplaince',
    component: AddComplianceView,
    layout: Layout,
    isAuth: true,
  },
  {
    path: 'configuration/addcab',
    component: AddCabView,
    layout: Layout,
    isAuth: true,
  },
  {
    path: 'configuration/addfeedback',
    component: AddFeedbackView,
    layout: Layout,
    isAuth: true,
  },
  { path: 'configuration/faq', component: FAQ, layout: Layout, isAuth: true },
  {
    path: 'configuration/faq/details',
    component: FAQView,
    layout: Layout,
    isAuth: true,
  },
];

// Vendor Route
export const routeConfigVendor = [
  { path: '/', component: Login, layout: null, isAuth: false },
  { path: '/login', component: Login, layout: null, isAuth: false },
  { path: '/otp', component: Otp, layout: null, isAuth: false },
  { path: '/dashboard', component: Dashboard, layout: Layout, isAuth: true },
  { path: '/sub-vendor', component: SubVendors, layout: Layout, isAuth: true },
  {
    path: '/sub-vendor/details',
    component: SubVendorDetails,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/sub-vendor/driver/details',
    component: ViewDriverVendor,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/sub-vendor/vehicle/details',
    component: VehicleDetails,
    layout: Layout,
    isAuth: true,
  },
  { path: '/driver', component: Drivers, layout: Layout, isAuth: true },
  {
    path: '/driver/details',
    component: ViewDriverVendor,
    layout: Layout,
    isAuth: true,
  },
  { path: '/vehicle', component: Vehicle, layout: Layout, isAuth: true },
  {
    path: '/vehicle/details',
    component: VehicleDetails,
    layout: Layout,
    isAuth: true,
  },
  { path: '/companies', component: Company, layout: Layout, isAuth: true },
  {
    path: '/companies/new-booking',
    component: OnBoardingForm,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/companies/companyprofile/:id',
    component: CompanyProfile,
    layout: Layout,
    isAuth: true,
  },
  { path: '/employees', component: Employee, layout: Layout, isAuth: true },
  {
    path: '/reservation',
    component: Reservation,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/reservation/new-reservation',
    component: NewReservation,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/reservation/bookingdetails',
    component: BookingDetails,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/operation/allrides/:tabs',
    component: AllRides,
    layout: Layout,
    isAuth: true,
  },
  { path: '/operation/allot', component: Allot, layout: Layout, isAuth: true },
  {
    path: '/operation/dispatch',
    component: Dispatch,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/operation/billing/:tabs',
    component: Billing,
    layout: Layout,
    isAuth: true,
  },
  { path: '/payment', component: Payment, layout: Layout, isAuth: true },
  {
    path: '/payment/newpayment',
    component: NewPayment,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/operation/billing/duty-slip',
    component: BillingDutySlip,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/operation/billing/performa-invoice',
    component: BillingPerformaInvoice,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/operation/billing/consolidate-invoice',
    component: BillingConsolidateInvoice,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/operation/allrides/bookingdetails',
    component: BookingDetails,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/operation/allot/bookingdetails',
    component: BookingDetails,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/operation/dispatch/bookingdetails',
    component: BookingDetails,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/operation/billing/bookingdetails',
    component: BookingDetails,
    layout: Layout,
    isAuth: true,
  },
  { path: '/report/revenue', component: Reports, layout: Layout, isAuth: true },
  { path: '/settings', component: Setting, layout: Layout, isAuth: true },
  {
    path: '/notification',
    component: Notification,
    layout: Layout,
    isAuth: true,
  },
  {
    path: 'report/booking',
    component: BookingReport,
    layout: Layout,
    isAuth: true,
  },
  {
    path: 'report/corporatecustomer',
    component: CorporateCustomer,
    layout: Layout,
    isAuth: true,
  },
  {
    path: 'operation/allotvehicle',
    component: AssignVehicleView,
    layout: Layout,
    isAuth: true,
  },
  {
    path: 'operation/allotdriver',
    component: AssignDriverView,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/payment/paymentdetails',
    component: PaymentDetails,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/compliance/:tabs',
    component: ComplianceTable,
    layout: Layout,
    isAuth: true,
  },
  {
    path: '/compliance/documents',
    component: ComplianceDocument,
    layout: Layout,
    isAuth: true,
  },
];

export const routeConfigSubVendor = [
  { path: '/subVendor/', component: SubVendorB2B, layout: null, isAuth: true },
];
